export default __webpack_public_path__ + "static/media/caution.43e3a5ef.svg";